// @ts-check
/**
 * @typedef {Object} ffRecentlyViewedCustomProperties
 * @property {Function} ffRestrains
 * @property {Function} ffResizeSlides
 * @property {() => Promise<void>} ffInit
 *
 * @typedef {ffRecentlyViewedCustomProperties & HTMLElement} ffRecentlyViewed
 */

if (!customElements.get("ff-recently-viewed")) {
  class FfRecentlyViewed extends HTMLElement {
    constructor() {
      super();

      /**
       * @type {FfSlider}
       */
      this.ffSlider = (() => {
        if (this.dataset.ffSliderSelector) {
          /**
           * @type {FfSlider | null}
           */
          const slider = this.querySelector(this.dataset.ffSliderSelector);
          if (slider) {
            return slider;
          } else {
            throw new Error(
              "Slider with selector: " +
                this.dataset.ffSliderSelector +
                " was not found"
            );
          }
        } else {
          throw new Error("Missing slider selector");
        }
      })();

      /**
       * @type {string[]}
       */
      this.ffProductsHandles = JSON.parse(
        localStorage.getItem("ff-recently-viewed") || "[]"
      );

      /**
       * Remove actual product from handles to avoid its rendering and place it again as the most recent product viewed
       * @type {string | null}
       */
      const actualProductHandle = this.querySelector(
        "[data-ff-recently-viewed-product-card]"
      )?.dataset.ffRecentlyViewedProductHandle;

      this.ffProductsHandles = this.ffProductsHandles.filter(
        (handle) => handle != actualProductHandle
      );

      if (this.ffProductsHandles.length > 0) {
        this.classList.add("ff-recently-viewed-container--with-products");
      }

      const productCardsRendering = Promise.allSettled(
        this.ffProductsHandles.map(async (productHandle) => {
          const res = await fetch(
            window["Shopify"].routes.root + productHandle
          );
          const text = await res.text();

          const html = new DOMParser().parseFromString(text, "text/html");
          /**
           * @type {string | null | undefined}
           */
          const productCardText = html.querySelector(
            "[data-ff-recently-viewed-product-card]"
          )?.textContent;

          if (productCardText) {
            /**
             * @type {HTMLElement | null}
             */
            const productCard = new DOMParser()
              .parseFromString(productCardText, "text/html")
              .querySelector(".swiper-slide");

            if (productCard) {
              this.ffSlider.ffSwiper.appendSlide(productCard);

              if (productCard.dataset.ffRecentlyViewedProductHandle) {
                this.ffProductsHandles.unshift(
                  productCard.dataset.ffRecentlyViewedProductHandle
                );
              }
            }
          }
        })
      );

      productCardsRendering.then(() => {
        this.ffSlider.ffRestrains();
      });

      //Add actual product handle to local storage
      if (
        actualProductHandle &&
        !this.ffProductsHandles.includes(actualProductHandle)
      ) {
        this.ffProductsHandles.unshift(actualProductHandle);

        if (this.ffProductsHandles.length > 8) {
          this.ffProductsHandles.length = 8;
        }

        localStorage.setItem(
          "ff-recently-viewed",
          JSON.stringify(this.ffProductsHandles)
        );
      }
    }
  }

  customElements.define("ff-recently-viewed", FfRecentlyViewed);
}
